import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import DependantFsaModal from './DependantFsaModal';

const DependantFSAModalDemo = () => {
  const [showDependedFSAModal, setShowDependedFSAModal] =
    React.useState<boolean>(false);

  const handleShowDependedFSAModal = () => setShowDependedFSAModal(true);
  const handleCloseDependedFSAModal = () => setShowDependedFSAModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Depended care FSA Modal</h4>
        <Button onMouseDown={handleShowDependedFSAModal}>Open Modal</Button>
        <DependantFsaModal
          showDependedFSAModal={showDependedFSAModal}
          handleCloseDependedFSAModal={handleCloseDependedFSAModal}
        />
      </Container>
    </Container>
  );
};

export default DependantFSAModalDemo;
